/*
 * @Description: 分销员管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-06 18:32:16
 * @LastEditTime: 2023-12-26 16:07:26
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 审核列表
  resellerList (querys) {
    return get('massage/admin/AdminReseller/resellerList', querys)
  },
  // 分销员详情
  resellerInfo (querys) {
    return get('massage/admin/AdminReseller/resellerInfo', querys)
  },
  // 申请分销员
  applyReseller (querys) {
    return post('massage/admin/AdminReseller/applyReseller', querys)
  },
  // 编辑/审核分销员
  resellerUpdate (querys) {
    return post('massage/admin/AdminReseller/resellerUpdate', querys)
  },
  // 选择用户
  noresellerUserList (querys) {
    return get('massage/admin/AdminReseller/noresellerUserList', querys)
  },
  // 数据统计
  partnerDataList (querys) {
    return get('massage/admin/AdminReseller/partnerDataList', querys)
  },
  // 查询分销员关系
  resellerRelationshipTop (querys) {
    return get('massage/admin/AdminReseller/resellerRelationshipTop', querys)
  },
  // 邀请的下级
  subReseller (querys) {
    return get('massage/admin/AdminReseller/subReseller', querys)
  },
  // 邀请的用户
  subUser (querys) {
    return get('massage/admin/AdminReseller/subUser', querys)
  },
  // 解除绑定
  delSubUser (querys) {
    return post('massage/admin/AdminReseller/delSubUser', querys)
  },
  // 订单列表
  resellerOrderList (querys) {
    return get('massage/admin/AdminReseller/resellerOrderList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/distribution.js